export default class TipoUbicacion{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/tipo_ubicaciones',
			"id": '/api/tipo_ubicaciones/:id',
			"new": '/api/tipo_ubicaciones',
			'delete': '/api/tipo_ubicaciones/:id'
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/tipoUbicacionesService.js